import { useState } from 'react';
import { Button, Modal, List, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CloseOutlined, UsergroupAddOutlined } from '@ant-design/icons';

const UserListModal = ({ spectators, isRoomCreator, removeUser, translationGroup }) => {
  const [visible, setVisible] = useState(false);

  const SpectatorsList = () => (
    <div
      id='scrollableDiv'
      style={{
        overflow: 'auto',
        padding: '0 16px',
        border: '1px solid rgba(140, 140, 140, 0.35)',
        position: 'relative',
        left: '1%',
        bottom: 0,
      }}
    >
      <InfiniteScroll
        dataLength={spectators.length}
        endMessage={<Divider plain>Список пользователей</Divider>}
        scrollableTarget='scrollableDiv'
        cancelText='Отмена'
      >
        <List
          dataSource={spectators}
          renderItem={item => (
            <List.Item key={item.name || 'нет данных'}>
              <List.Item.Meta
                title={<a>{item.email || 'нет данных'}</a>}
                description={`room-${item.id}` === translationGroup ? 'Администратор' : item.tel || 'нет данных'}
              />
              {isRoomCreator && !(`room-${item.id}` === translationGroup) && (
                <div>
                  <Button icon={<CloseOutlined />} size='small' onClick={() => removeUser(item)} danger />
                </div>
              )}
            </List.Item>
          )}
        />
      </InfiniteScroll>
    </div>
  );

  return (
    <>
      <Button type='primary' onClick={() => setVisible(true)} icon={<UsergroupAddOutlined />} />
      <Modal title='Актуальный список пользователей' open={visible} footer={null} onCancel={() => setVisible(false)}>
        <SpectatorsList />
      </Modal>
    </>
  );
};

export default UserListModal;
